<template>
  <div class="interstitial">
    <b-container class="text-center">
      <b-row align-h="center">
        <b-col lg="6" md="8" sm="12">
          <icon-interest />
          <h2>Alright, now let’s talk about your <span class="underline text-reset">major</span>.</h2>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import IconInterest from '../animatedicons/IconInterest.vue'

export default {
  name: 'CareerInterstitial',
  props: {
    user: Object
  },
  mounted: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    this.delay = window.setTimeout(() => this.$emit('completed'), 3000);
    container.classList.add('container-hidden');
  },
  destroyed: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    window.clearTimeout(this.delay);
    container.classList.remove('container-hidden');
  },
  components: {
    IconInterest
  }
}
</script>

<style scoped>
</style>
